// extracted by mini-css-extract-plugin
export default {"root":"StandardEquipmentForm_root__9L46Z","listContainer":"StandardEquipmentForm_listContainer__Repen","listItem":"StandardEquipmentForm_listItem__dA1E1"};